import { BagUpsellProductOption, BagUpsellRail, BagUpsellRailSkeleton } from './components';

export const BagUpsell = {
  Rail: BagUpsellRail,
  RailSkeleton: BagUpsellRailSkeleton,
  ProductOption: BagUpsellProductOption,
};
